import { ApiResponseType } from '../enum/response-type.type';

export interface IRequestDriver {
  send(method: string, baseUrl: string, url: string, data: any, usesAuth: boolean, headers: Record<string, string>, responseType?: ApiResponseType): Promise<any>;
  getHeaders(response: any): Record<string, string>;
  getBody(response: any): Promise<any>;
  getContentAsText(response: any): Promise<string>;
  getContentAsBlob(response: any): Promise<Blob>;
  upload(method: string, baseUrl: string, url: string, data: string | null, projectId: string, content: string | Blob, fileName: string, headers?: Record<string, string>): Promise<any>;
}